import PropTypes from 'prop-types';
import React from 'react';
import { withStyles } from 'tss-react/mui';

import NavigationClose from '@mui/icons-material/Close';
import { Card, IconButton, Typography } from '@mui/material';

import isomorphicLocalStorage from 'main/modules/isomorphic-local-storage';

const styles = {
    root: {},
    card: {
        border: '1px solid #ECECEC',
        marginBottom: '16px',
        padding: '16px',
        position: 'relative'
    },
    cardContent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '@media (max-width: 720px)': {
            display: 'initial',
            flexDirection: 'column',
            '& h3': {
                textAlign: 'center'
            }
        }
    },
    '.card&p': {
        lineHeight: 1,
        margin: 0
    }
};

class DemoTour extends React.Component {
    componentDidMount() {
        this.setState({
            demoOpen: !isomorphicLocalStorage.getItem(this.props.demoName)
        });
    }

    handleDemoClose = () => {
        isomorphicLocalStorage.setItem(this.props.demoName, 'true');
        this.setState({
            demoOpen: false
        });
    };

    render() {
        const { icon, cardStyle, children, demoMessage, className, staticBanner } = this.props;
        const classes = withStyles.getClasses(this.props);
        if (!this.state || !this.state.demoOpen) {
            return false;
        }

        return (
            <Card className={[className, classes.card].filter(Boolean).join(' ')}>
                <div className={classes.cardContent}>
                    {icon}

                    <Typography variant="body2" component="div" style={Object.assign({ flex: 1 }, cardStyle)}>
                        {children || demoMessage}
                    </Typography>

                    {!staticBanner && (
                        <div className="vulners-demo-tour-close">
                            <IconButton onClick={this.handleDemoClose} color="primary" size="large">
                                <NavigationClose />
                            </IconButton>
                        </div>
                    )}
                </div>
            </Card>
        );
    }
}

DemoTour.propTypes = {
    icon: PropTypes.node,
    cardStyle: PropTypes.object,
    children: PropTypes.node,
    demoName: PropTypes.string,
    demoMessage: PropTypes.node,
    className: PropTypes.string,
    classes: PropTypes.object,
    staticBanner: PropTypes.bool
};

export default withStyles(DemoTour, styles);
